module.exports = __webpack_public_path__ + "img/activity-success-header.8f464cc2.png";